import { Content } from '@radix-ui/react-tabs'
import { forwardRef } from 'react'
import { cn } from '#src/cn.ts'

export const TabsContent = forwardRef<
  React.ElementRef<typeof Content>,
  React.ComponentPropsWithoutRef<typeof Content>
>(({ className, ...props }, ref) => (
  <Content
    ref={ref}
    className={cn(
      'ring-offset-white focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-zinc-950 focus-visible:ring-offset-2 dark:ring-offset-zinc-950 dark:focus-visible:ring-zinc-300',
      className
    )}
    {...props}
  />
))
TabsContent.displayName = Content.displayName
